const DAY_TOKEN_LABEL: Record<string, string> = {
  monday: "MON",
  mon: "MON",
  tuesday: "TUE",
  tues: "TUE",
  tue: "TUE",
  wednesday: "WED",
  wed: "WED",
  thursday: "THU",
  thurs: "THU",
  thu: "THU",
  friday: "FRI",
  fri: "FRI",
  saturday: "SAT",
  sat: "SAT",
  sunday: "SUN",
  sun: "SUN",
};

/** Normalize day token; strip full-name "day" suffix (Monday → MON). */
function normalizeDayToken(token: string): string {
  const raw = token.trim();
  if (!raw) {
    return raw;
  }
  const key = raw.toLowerCase();
  if (DAY_TOKEN_LABEL[key]) {
    return DAY_TOKEN_LABEL[key];
  }
  if (/^[A-Z]{3}$/i.test(raw)) {
    return raw.toUpperCase();
  }
  if (/day$/i.test(raw) && raw.length > 4) {
    const shortened = raw.replace(/days?$/i, "").trim();
    const mapped = DAY_TOKEN_LABEL[shortened.toLowerCase()];
    if (mapped) {
      return mapped;
    }
    return shortened;
  }
  return raw;
}

function formatWorkingDaysList(days: unknown[]): string {
  return days.map(d => normalizeDayToken(String(d))).filter(Boolean).join(", ");
}

/** Display `working_days` from API (array or Python-style string). */
export function formatWorkingDaysForGrid(value: unknown): string {
  if (value == null || value === "") {
    return "-";
  }
  if (Array.isArray(value)) {
    return formatWorkingDaysList(value) || "-";
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed.startsWith("[")) {
      try {
        const normalized = trimmed.replace(/'/g, '"').replace(/,\s*/g, ", ");
        const parsed = JSON.parse(normalized);
        if (Array.isArray(parsed)) {
          return formatWorkingDaysList(parsed) || "-";
        }
      } catch {
        /* use raw string */
      }
    }
    return (
      trimmed
        .split(",")
        .map(part => normalizeDayToken(part))
        .filter(Boolean)
        .join(", ") || "-"
    );
  }
  return normalizeDayToken(String(value));
}
